import { useRef, useState } from 'react'

export default function UseScroll(parentClass: any, childClass: any, scrollUnit = 10, scrollRange = scrollUnit / 4, snapToUnit = false) {
  const [hideArrow, setHideArrow] = useState<'' | 'prev' | 'next' | 'both'>('')
  const [scrollBehavior, setScrollBehavior] = useState<'unset' | 'smooth'>('smooth')
  const [mouseDown, setMouseDown] = useState(false)
  const [startX, setStartX] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)
  // ติดตามเป้าหมายล่าสุดที่ scrollTo สั่ง เพื่อไม่ให้คลิกเร็วๆ
  // ระหว่าง smooth-scroll animation อ่าน scrollLeft กลางทางแล้วคำนวณผิด
  const lastTargetRef = useRef<number | null>(null)
  const animationTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const onPressArrow = (type: 'onPrev' | 'onNext' | 'onLoad') => {
    const slider: any = document.querySelector(`${parentClass}`)
    const childSlider: any = document.querySelector(`${childClass}`)
    if (!slider || !childSlider) return

    if (type === 'onLoad') {
      handleScroll(slider.offsetWidth, slider.scrollLeft, childSlider.offsetWidth)
    } else {
      const maxScroll = childSlider.offsetWidth - slider.offsetWidth
      // snapToUnit: เลื่อนทีละ "card" โดย snap ไปขอบ card ถัดไป/ก่อนหน้า
      // วัด card width จริงจาก DOM (รับมือกับเคสที่ effective width ≠ scrollUnit เช่น padding/margin/zoom)
      let newLeft: number
      if (snapToUnit) {
        const liveScroll = slider.scrollLeft
        const firstCard = childSlider.querySelector('.graph-appointment') as HTMLElement | null
        const measuredUnit = firstCard?.offsetWidth ?? scrollUnit
        const effectiveUnit = measuredUnit > 0 ? measuredUnit : scrollUnit
        const tolerance = Math.max(2, effectiveUnit / 100)
        const animating = lastTargetRef.current !== null && Math.abs(liveScroll - lastTargetRef.current) > tolerance
        const current = animating ? (lastTargetRef.current as number) : liveScroll
        const nearestEdge = Math.round(current / effectiveUnit) * effectiveUnit
        const atEdge = Math.abs(current - nearestEdge) <= tolerance
        if (type === 'onNext') {
          const target = atEdge ? nearestEdge + effectiveUnit : Math.ceil(current / effectiveUnit) * effectiveUnit
          newLeft = Math.min(target, maxScroll)
        } else {
          const target = atEdge ? nearestEdge - effectiveUnit : Math.floor(current / effectiveUnit) * effectiveUnit
          newLeft = Math.max(target, 0)
        }
        lastTargetRef.current = newLeft
      } else {
        newLeft = type === 'onNext'
          ? Math.min(slider.scrollLeft + scrollUnit, maxScroll)
          : Math.max(slider.scrollLeft - scrollUnit, 0)
      }

      slider.scrollTo({ left: newLeft, behavior: 'smooth' })

      if (animationTimerRef.current) clearTimeout(animationTimerRef.current)
      animationTimerRef.current = setTimeout(() => {
        handleScroll(Math.round(slider.offsetWidth), Math.round(slider.scrollLeft), Math.round(childSlider.offsetWidth))
        lastTargetRef.current = null
        animationTimerRef.current = null
      }, 350)
    }
  }

  const handleScroll = (width: number, scroll: number, childOffsetWidth: number) => {
    const slider: any = document.querySelector(`${parentClass}`)
    if (!slider) return
    if (childOffsetWidth <= width) {
      setHideArrow('both')
    } else if (scroll < scrollRange && width !== childOffsetWidth) {
      setHideArrow('prev')
    } else if (width + scroll >= childOffsetWidth - scrollRange) {
      setHideArrow('next')
    } else {
      setHideArrow('')
    }
  }

  const startDragging = (event: any) => {
    const slider: any = document.querySelector(`${parentClass}`)
    setMouseDown(true)
    setStartX(event.pageX - slider.offsetLeft)
    setScrollLeft(slider.scrollLeft)
  }

  const stopDragging = (event: any) => {
    setMouseDown(false)
    setScrollBehavior('smooth')
  }

  const handleDragging = (event: any) => {
    const slider: any = document.querySelector(`${parentClass}`)
    const childSlider: any = document.querySelector(`${childClass}`)
    event.preventDefault()
    setScrollBehavior('unset')
    if (!mouseDown) return
    const x = event.pageX - slider.offsetLeft
    const scroll = x - startX
    slider.scrollLeft = scrollLeft - scroll
    // user เลื่อนเอง → เคลียร์ target ค้าง เพื่อให้คลิกครั้งต่อไปคำนวณจากตำแหน่งจริง
    lastTargetRef.current = null
    if (animationTimerRef.current) {
      clearTimeout(animationTimerRef.current)
      animationTimerRef.current = null
    }
    handleScroll(slider.offsetWidth, slider.scrollLeft, childSlider.offsetWidth)
  }

  return { hideArrow, scrollBehavior, onPressArrow, handleScroll, startDragging, stopDragging, handleDragging }
}
